import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as CustomerStateController from '../../store/StateControllers/Customers/CustomersStateController';
import { Customer, CustomerContact } from '../../store/Models/Customers/Customer';
import { MyCustomersProps } from './MyCustomersCommon';
import { ToxnotSignInRequiredComponent } from '../core/BaseApplicationComponents/ToxnotSignInRequiredComponent';

import './MyCustomers.css';

class MyCustomerInfo extends ToxnotSignInRequiredComponent<MyCustomersProps> {

    // ===============================================================================

    protected override getDisallowedRoles() {
        return [];
    }

    // ===============================================================================

    protected renderConcreteComponent() {

        if (this.props.currentlySelectedCustomerId === null) {
            throw new Error("Customer was null in MyCustomerInfo.");
        }

        const customer = this.props.customerIdToCustomerTable[this.props.currentlySelectedCustomerId];

        return (
            <div id="customer-info-root">
                <div className="text-right">
                    <div id="save-status">{this.localizeString("All Data Saved")}</div>
                </div>
                <div className="grouped-data">
                    <div className="group">
                        <div className="title">
                            {this.localizeString("Company Name")}
                        </div>
                        <div className="content">
                            <div className="form-inline">
                                <input type="text" id="company-name-input" className="form-control" onChange={e => this.companyNameInput_onChange({ companyName: e.target.value })} value={customer.companyName ?? ""} placeholder={this.localizeString("Company Name")} disabled={!this.props.appServices.userContext?.isEditorOrMarketingRole}/>
                            </div>
                        </div>
                    </div>
                    <div className="group">
                        <div className="title">
                            {this.localizeString("Contacts")}
                        </div>
                        <div className="content">
                            {this.props.appServices.userContext?.isEditorOrMarketingRole && <p><button id="add-contact-button" className="btn btn-default" onClick={e => this.addContact_click()}>{this.localizeString("Add Contact")}</button></p>}
                            {customer.customerContacts.length === 0 &&
                                <p>
                                    {this.localizeString("There are no contacts set up yet.")}
                                </p>
                            }
                            {customer.customerContacts.map((c, i) => (
                                <div key={i} className="customer-contact-row form-inline">
                                    <input type="text" id="contact-name-input" className="form-control" onChange={e => this.customerContactsInputForm_onChange(i, { name: e.target.value })} value={c.name} placeholder={this.localizeString("Contact Name")} disabled={!this.props.appServices.userContext?.isEditorOrMarketingRole} />
                                    <input type="text" id="contact-email-input" className="form-control" onChange={e => this.customerContactsInputForm_onChange(i, { email: e.target.value })} value={c.email} placeholder={this.localizeString("Contact Email")} disabled={!this.props.appServices.userContext?.isEditorOrMarketingRole} />
                                    {this.props.appServices.userContext?.isEditor && < button className="btn btn-sm btn-toxnot-danger" onClick={e => { this.removeContact_click(i) }}><span className="glyphicon glyphicon-remove"></span></button>}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // ===============================================================================

    //
    // UI Events
    //

    private companyNameInput_onChange = (updatedCustomer: Partial<Customer>) => {
        this.props.updateSelectedCustomer(updatedCustomer);
    }

    // ===============================================================================

    private customerContactsInputForm_onChange = (index: number, updatedContact: Partial<CustomerContact>) => {
        const customer = this.props.customerIdToCustomerTable[this.props.currentlySelectedCustomerId!];

        customer.customerContacts[index] = {
            ...customer.customerContacts[index],
            ...updatedContact
        };

        this.props.updateSelectedCustomer(customer);
    }

    // ===============================================================================

    private addContact_click = () => {
        const customer = this.props.customerIdToCustomerTable[this.props.currentlySelectedCustomerId!];

        customer.customerContacts.push({
            name: "",
            email: ""
        });

        this.props.updateSelectedCustomer(customer);
    }

    // ===============================================================================

    private removeContact_click = (index: number) => {
        const customer = this.props.customerIdToCustomerTable[this.props.currentlySelectedCustomerId!];

        customer.customerContacts.splice(index, 1);

        this.props.updateSelectedCustomer(customer);
    }
}

export default connect(
    (state: ApplicationState) => ({ appServices: state.appServices, ...state.myCustomersState }),
    CustomerStateController.actionCreators
)(MyCustomerInfo as any); 

